import comp from "./SideBar";
export default comp;
